import React, { useState, useEffect } from 'react';
import { Button, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';
import Constants from '../Constants';
import '../App.css';

const render_feature_item = (feature, index) => {
	const value = feature.limit_value ? String(feature.limit_value) : 'Included';
	return (
		<div key={index} className="payment-feature-item">
			<span className="payment-feature-name">{feature.name}</span>
			<span className="payment-feature-value">{value}</span>
		</div>
	);
};

const render_plan_summary = (plan) => {
	if(!plan) {
		return <Alert variant="warning">No plan selected.</Alert>;
	}
	return (
		<div className="payment-plan-summary">
			<h5 className="payment-plan-name">{plan.name}</h5>
			<p className="payment-plan-price">{'$' + (plan.price_in_cents / 100).toFixed(2) + ' / ' + Constants.get_billing_interval_label(plan.billing_interval)}</p>
			<p className="payment-plan-description">{plan.description}</p>
			{plan.features && (plan.features.length > 0) ? (
				<div className="payment-feature-list">
					{plan.features.map(function(feature, index) { return render_feature_item(feature, index); })}
				</div>
			) : null}
		</div>
	);
};

function PaymentView() {
	const planJSON = localStorage.getItem(Constants.SIGNUP_SELECTED_PLAN);
	const selected_plan = planJSON ? JSON.parse(planJSON) : null;

	const user_email = localStorage.getItem(Constants.SIGNUP_USER_EMAIL);

	const [loading, set_loading] = useState(false);
	const [error, set_error] = useState('');

	useEffect(() => {
		if(user_email) {
			axios.post(Constants.SERVER_URL + '/api/payment/cancel_pending_sessions', { user_email })
				.catch(err => console.error('PaymentView - cancel_pending_sessions error:', err.message));
		}
	}, []);

	const handle_proceed = async () => {
		try {
			set_loading(true);
			set_error('');

			if(!selected_plan || !selected_plan.id) {
				set_error('No plan selected.');
				return;
			}

			if(!user_email) {
				set_error('No email found. Please go back and enter your email.');
				return;
			}

			const response = await axios.post(
				Constants.SERVER_URL + '/api/payment/checkout',
				{ user_email: user_email, plan_id: selected_plan.id }
			);

			if(response.data && response.data.checkout_url) {
				window.location.href = response.data.checkout_url;
				return;
			}

			if(response.data && response.data.redirect_url) {
				window.location.href = response.data.redirect_url;
				return;
			}

			set_error('Failed to start checkout session.');
		} catch (error) {
			const msg = error.response && error.response.data && error.response.data.message;
			set_error(msg || 'Error initiating payment. Please try again.');
		} finally {
			set_loading(false);
		}
	};

	return (
		<main className="payment-main">
			<div className="payment-card">
				<h4 className="payment-title">Complete Your Subscription</h4>
				<p className="payment-subtitle">Review your plan before proceeding to secure payment.</p>

				{error ? <Alert variant="danger">{error}</Alert> : null}

				{render_plan_summary(selected_plan)}

				{user_email ? (
					<p className="payment-email-display">{user_email}</p>
				) : null}

				<p className="payment-stripe-note">You will be redirected to Stripe for secure payment.</p>

				<div className="payment-actions">
					<Button
						variant="success"
						className="payment-btn"
						disabled={loading || !selected_plan}
						onClick={handle_proceed}>
						{loading ? <Spinner size="sm" animation="border" /> : 'Proceed to Payment'}
					</Button>
				</div>
			</div>
		</main>
	);
}

export default PaymentView;
